import React from 'react';

import Title from '../Title';
import ChartLabel from '../ChartLabel';
import StackedChart from '../Charts/StackedChart';

import './index.scss';


const Details = ({labels, acceptData, declineData}) => {

  return <div className='details'>
    <div className='details__wrapper'>
      <Title title='Details:'/>
      <div className='details__labels'>
        <ChartLabel title='Accepts' isDetails />
        <ChartLabel title='Declines' isColorRed isDetails />
      </div>
    </div>
    <StackedChart labels={labels} acceptData={acceptData} declineData={declineData}/>
  </div>;
};

export default Details;
